export default __webpack_public_path__ + "static/media/3rdperk.d552fd79.jpg";